import cn from 'classnames'
import { colord } from 'colord'
import styled from 'styled-components'

interface MenuProps {
  $isSelected: boolean
}

export const Menu = styled.div.attrs(({ $isSelected }: MenuProps) => ({
  className: cn(
    'text-14 clickable px-20 py-8',
    $isSelected ? 'text-primary text-semibold' : 'text-medium'
  ),
}))<MenuProps>`
  &:hover {
    background-color: ${({ theme }) =>
      colord(theme.colors.primary).alpha(0.2).toHex()};
`
